export default [
    {
        path: '/check-account',
        name: 'Checking Account',
        component: () => import('@/views/check-account'),
    },
];



// WEBPACK FOOTER //
// ./src/views/check-account/route.js